import React, { useState } from "react";
import { Drawer } from "antd";
import Select from "react-select";
import { useParams, useHistory } from "react-router-dom";

const Institution = ({
  onSave,
  record = {
    name: "Institution",
    begunOn: 2020,
    graduatedOn: 2020,
    faculty: "Medicine",
    course: "Health Information",
    finalGrade: "First Class",
    documents: ["DEGREE"]
  },
}) => {
  const [visible, toggleVisible] = useState(true);
  const [name, setName] = useState(record?.name);
  const [begunOn, setStartYear] = useState(record?.begunOn);
  const [graduatedOn, setEndYear] = useState(record?.graduatedOn);
  const [faculty, setLocation] = useState(record?.faculty);
  const [course, setCourse] = useState(record?.course);
  const [finalGrade, setFinalGrade] = useState(record?.finalGrade);
  const [documents, setDocuments] = useState([]);
  
  const history = useHistory();
  const { index } = useParams();

  const modify = (e) => {
    switch (e.target.name) {
      case "name":
        setName(e.target.value);
        break;

      case "begunOn":
        setStartYear(e.target.value);
        break;

      case "graduatedOn":
        setEndYear(e.target.value);
        break;

      case "faculty":
        setLocation(e.target.value);
        break;

      case "course":
        setCourse(e.target.value);
        break;

      case "finalGrade":
        setFinalGrade(e.target.value);
        break;

      default:
        break;
    }
  };

  const modifyCert = (selectedOption) => {
    if (selectedOption && selectedOption.value) {
      setDocuments([...documents, selectedOption.label]);
    }
  };

  const close = () => {
    toggleVisible();
    setTimeout(() => history.goBack(), 300);
  };

  const save = () => {
    onSave(
      {
        name,
        begunOn,
        graduatedOn,
        faculty,
        course,
        finalGrade,
        documents,
      },
      index
    );
    close();
  };

  return (
    <Drawer
      closable
      maskClosable
      visible={visible}
      onClose={close}
      footer={
        <div className="w-full text-right">
          <button
            onClick={save}
            className="text-white mr-2 hisani-btn-orange font-medium rounded-lg text-sm px-5 py-2.5 text-center"
          >
            Save
          </button>
        </div>
      }
      width="30%"
    >
      <p className="font-extrabold text-2xl mb-0">New Institution</p>
      <div className="flex flex-wrap mt-3">
        <div className="w-full px-3 mb-1">
          <>
            <label
              className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              htmlFor="grid-name"
            >
              Institution Name
            </label>
            <input
              className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
              id="grid-name"
              name="name"
              value={name}
              onChange={modify}
              type="text"
              placeholder="Institution Name"
            />
          </>
        </div>
        <div className="w-full px-3 mb-1">
          <>
            <label
              className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              htmlFor="grid-name"
            >
              Begun On
            </label>
            <input
              className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
              id="grid-begunOn"
              name="begunOn"
              value={begunOn}
              onChange={modify}
              type="date"
              placeholder="Begun On"
            />
          </>
        </div>
        <div className="w-full px-3 mb-1">
          <>
            <label
              className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              htmlFor="grid-name"
            >
              Graduated On
            </label>
            <input
              className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
              id="grid-graduatedOn"
              name="graduatedOn"
              value={graduatedOn}
              onChange={modify}
              type="date"
              placeholder="Graduated On"
            />
          </>
        </div>
        <div className="w-full px-3 mb-1">
          <>
            <label
              className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              htmlFor="grid-name"
            >
              Faculty
            </label>
            <input
              className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
              id="grid-faculty"
              name="faculty"
              value={faculty}
              onChange={modify}
              type="text"
              placeholder="faculty"
            />
          </>
        </div>
        <div className="w-full px-3 mb-1">
          <>
            <label
              className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              htmlFor="grid-name"
            >
              Course
            </label>
            <input
              className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
              id="grid-course"
              name="course"
              value={course}
              onChange={modify}
              type="text"
              placeholder="course"
            />
          </>
        </div>
        <div className="w-full px-3 mb-1">
          <>
            <label
              className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              htmlFor="grid-name"
            >
              Final Grade
            </label>
            <input
              className="appearance-none block w-full bg-gray-200 text-gray-700 border border-gray-200 rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
              id="grid-finalGrade"
              name="finalGrade"
              value={finalGrade}
              onChange={modify}
              type="text"
              placeholder="Final Grade"
            />
          </>
        </div>
        <div className="w-full px-3 mb-1">
          <>
            <label
              className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
              htmlFor="grid-name"
            >
              Certification
            </label>
            <Select
              name="certification"
              value={documents}
              onChange={(opt)=>{setDocuments([...documents, opt.label])}}
              options={[
                "KCPE",
                "KCSE",
                "Certificate",
                "Diploma",
                "Degree",
                "Masters",
                "PHD",
              ]?.map((cert) => ({ label: cert, value: cert }))}
              placeholder={"Select Certification"}
            />
          </>
        </div>
      </div>
    </Drawer>
  );
};

export default Institution;
